const stringifyParams = (params) => {
  const queryParams = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');
  return (queryParams && `?${queryParams}`) || '';
};

export default stringifyParams;
